export const DraggableItem = ({
    children,
    handleDragOvers2,
    data,
    calculateMinutes,
    millisecondsSinceMidnightUTC,
    zoomInOut,
    weeklyView
}) => {
    return (
        <section 
            className={`d-flex ${!weeklyView && "px-2"}`} 
            id={`sequenceId${data?.sequence}`}
            onDragOver={(e) => handleDragOvers2(e, data?.uuid)}
            style={{
                top: `${calculateMinutes(millisecondsSinceMidnightUTC(data?.startAt))*zoomInOut}px`,
                position: "absolute", zIndex: `${data?.sequence}`,
                width: "100%",
                overflow: "hidden",
            }}
        >
            <div
                style={{
                    height: `${calculateMinutes(data?.totalDuration)*zoomInOut}px`, 
                    // width: "36px", 
                    width: "100%", 
                    position:"relative"
                }}
            >
                {children}
            </div>
        </section>
    )
}